/** @jsxImportSource @emotion/react */

import React, { useState, useEffect } from "react";
import tw from "twin.macro";
import "../Components/style.css";
import vendingmachine from "../Images/vendingmachine.png";
import HeaderLogo from "../Images/logo.png";
import { useDispatch, useSelector } from "react-redux";
import { AppReducer } from "./Redux/AppSlice";
import WideNavBar from "./WideNavBar";

const SignInContainer = tw.div`relative bg-white`;
const Container = tw.div`w-full  mt-28 `;
const FlexContainer = tw.div`md:flex justify-center md:mx-96 shadow-2xl`;
const LeftContainer = tw.div`md:w-1/2  flex justify-center   bg-white`;
const RightContainer = tw.div`md:w-1/2  py-20 flex justify-center bg-gray-200`;

const FormContainer = tw.div` w-full `;
const LogoContainer = tw.div`flex justify-center`;
const InputsContainer = tw.div`w-full `;
const InputFlexContainer = tw.div`flex mt-10 justify-center`;
const ButtonContainer = tw.div`my-10 flex justify-center text-xl`;

const InputContainer = tw.input`p-4 w-9/12 text-xl bg-white`;
const ForgetPassword = tw.div`flex  my-6 justify-end mr-24`;
const DemoCredential = tw.div`text-center`;

export default () => {
  const number = useSelector((state) => state.AppComponent.value);
  const dispatch = useDispatch();
  const [user_email, set_user_email] = useState("");
  const onChangeUsername = (e) => {
    set_user_email(e.target.value);
  };
  const [user_password, set_user_password] = useState("");
  const onChangeUserpassword = (e) => {
    set_user_password(e.target.value);
  };
  const sign_in = () => {
    if (user_email === "demo@vending.com" && user_password === "demopassword") {
      dispatch(AppReducer(2));
    } else {
      alert("Invalid user email password");
    }
  };

  return (
    <SignInContainer>
      {/* <WideNavBar /> */}
      <Container>
        <FlexContainer>
          <LeftContainer>
            <img src={vendingmachine} width="100%" class="loginImage" />
          </LeftContainer>
          <RightContainer>
            <FormContainer>
              <LogoContainer>
                <img src={HeaderLogo} width="40%" />
              </LogoContainer>

              <InputsContainer>
                <InputFlexContainer>
                  <InputContainer
                    value={user_email}
                    onChange={(e) => onChangeUsername(e)}
                    type="text"
                    placeholder="Email Address"
                  />
                </InputFlexContainer>
                <InputFlexContainer>
                  <InputContainer
                    value={user_password}
                    onChange={(e) => onChangeUserpassword(e)}
                    type="password"
                    placeholder="Password"
                  />
                </InputFlexContainer>
                <ForgetPassword>forget password?</ForgetPassword>
                <ButtonContainer>
                  {/* <button class="button button--pandora">
                    <span onClick={() => sign_in()}>Sign In</span>
                  </button> */}

                  <button class="button button--pandora">
                    <span onClick={() => dispatch(AppReducer(2))}>Sign In</span>
                  </button>
                </ButtonContainer>
              </InputsContainer>

              <DemoCredential>
                Click on <span tw=" font-semibold">SignIn Button</span> for Demo
                content
              </DemoCredential>

              {/* <DemoCredential>
                Details for Demo login <br />
                Email: <span tw=" font-semibold">demo@vending.com</span> <br />
                Password: <span tw=" font-semibold">demopassword</span>
              </DemoCredential> */}
            </FormContainer>
          </RightContainer>
        </FlexContainer>
      </Container>
    </SignInContainer>
  );
};
